const startConfig = require('../apiConfig')
const comHttpUrl = startConfig.baseUrl()

module.exports = {

  list: comHttpUrl + 'limbo/list',
  one: comHttpUrl + 'limbo/one',
  onelimboPaging: comHttpUrl + 'limbo/onelimboPaging'
}



// WEBPACK FOOTER //
// ./src/api/modules/linbo.js